let notifications = {
  title: 'Notificações',
  new: 'novo',
  unread: function (plural = false) {
    return `não lido${(plural ? 's' : '')}`
  }
}

export default notifications
